import { Zone, Address } from '../../types/noocoDbTypes'
import { SuccessReturnBody, getSuccessReturnBody, AcceptedReturnBody, headers} from '../general';
export enum Phase {
  Conception = 34,
  Programmation = 2,
  Esquisse = 3,
  APS = 4,
  APD = 5,
  PRO_DCE = 6,
  EXE = 7,
  Construction = 8,
  Réalisation = 35,
  Exploitation = 9
}

export type ProjectUnit = 'total' | 'm2' 
export type Destination = zone | building | plot | buildingSite
export type EpcmZoneCategory = 'CE1' | 'CE2'
export type status = 'RUNNING' | 'SUCCEEDED' | 'FAILED' | 'TIMED_OUT' | 'ABORTED'

export const allowedPhasesByTemplate = {
  're2020': [Phase.Programmation, Phase.Esquisse, Phase.APS, Phase.APD, Phase.PRO_DCE, Phase.Construction, Phase.Exploitation],
  'epcm': [Phase.Conception, Phase.Programmation, Phase.Réalisation, Phase.Exploitation],
  'nooco':[],
  'bbca': [],
  'exploitation': [],
  'datacenter': [],
  'airport': [],
  'renovation': [],
  'outdoor': []
}

export const additionnalRequiredBodyKeysByTemplate = {
  'nooco': [],
  're2020': ["permitDate", "phase", "plot", "hasBuildingSite", "buildingSiteDuration"],
  'epcm': ["permitDate", "phase", "plot", "hasBuildingSite", "buildingSiteDuration"],
  'bbca': [],
  'exploitation': [],
  'datacenter': [],
  'airport': [],
  'renovation': [],
  'outdoor': []
} 

export const additionnalRequiredZoneKeysByTemplate = {
  'epcm': ['IsConnectedToUrbanNetwork', 'category', 'atticArea', 'isSharedArea', 'dwellingCount', 'occupantCount', 'surfaceParkingSpotCount', 'pluSurfaceParkingSpotCount', 'undergroundParkingSpotCount', 'pluUndergroundParkingSpotCount', 'thermalSurface'],
  'nooco': [],
  're2020': ['occupantCount'],
  'bbca': [],
  'exploitation': [],
  'datacenter': [],
  'airport': [],
  'renovation': [],
  'outdoor': []
}

export const additionnalRequiredZoneKeysByTemplateAndZoneType = {
  're2020': {
    'Collective housing': ['dwellingCount'],
    'Individual house': ['atticArea', 'dwellingCount'],
    'Offices': ['zoneFootprint'],
  },
  'epcm': {
  },
  'nooco': {
  },
  'bbca': {
  },
  'exploitation': {
  },
  'datacenter': {
  },
  'airport': {
  },
  'renovation': {
  },
  'outdoor': {
  }
}

export const publicKeysEquivalent = {
  'surfaceParkingSpotCount': 'nbParkingSpotsSurface',
  'pluSurfaceParkingSpotCount': 'nbParkingSpotsSurfacePlu',
  'undergroundParkingSpotCount': 'nbParkingSpotsUnderground',
  'pluUndergroundParkingSpotCount': 'nbParkingSpotsUndergroundPlu',
  'thermalSurface': 'srt',
  'occupantCount': 'nbOccupants',
  'dwellingCount': 'nbLgt',
  'atticArea': 'sCombles',
  'zoneFootprint': 'groundExpansion'
} as const;

export enum ProjectTemplateType {
  'nooco' = 1,
  'bbca' = 12,
	'exploitation' = 5,
	'airport' = 6,
	'datacenter' = 7,
	'outdoor' = 8,
	're2020'  = 2,
	'epcm'  = 3,
	'renovation' = 4,
}

export const allowedZoneTypesByTemplate= {
  'nooco': [67, 100, 2, 1, 10, 11, 24, 25, 19, 4, 5, 6, 21, 22, 23, 8, 26, 27, 31, 30, 9, 32, 34, 35, 16, 36, 37, 15, 33, 28, 29, 3, 18, 38, 39, 40, 41], // all types
  're2020': [17, 2, 1, 11, 8],
'epcm': [2, 1, 10, 11, 24, 25, 19, 4, 5, 6, 21, 22, 23, 8, 26, 27, 31, 30, 9, 32, 34, 35, 16, 36, 37, 15, 33, 28, 29, 3, 18, 38],
  'bbca': [1, 8],
  'exploitation': [],
  'datacenter': [],
  'airport': [],
  'renovation': [16, 8, 1, 14 ,20, 12, 18, 3, 10, 13, 19, 17, 11, 9, 38],
  'outdoor': [41]
}

export enum ZoneType {
'Parking' = 67, 
'Museum' = 100,
'Individual house' = 2,
'Collective housing' = 1,
'Early childhood facility' = 10 ,
'Primary education' =11,
'Secondary education Daytime' =24, 
'Secondary education Night time' =25, 
'University and research facility' =19,
'Hotel 0 to 1 star (night part)'= 4,
'Hotel 2 stars (night part)' = 5,
'Hotel 3 stars (night part)' = 6,
'Hotel 4 and 5 stars (night part)' =21, 
'Hotel 0, 1 and 2 stars (day part)' =22,
'Hotel 3, 4 and 5 stars (day part)' =23,
'Offices' =8,
'Restaurant Continuous commercial -18h/d 7 days a week' =26,
'Restaurant 1 meal/day, 5 days a week' =27,
'Restaurant 2 meals/day, 7 days a week' =31,
'Restaurant 2 meals/day, 6 days a week' =30,
'Commerce' =9,
'Gymnasium and fitness room School' =32, 
'Health institution Night time' =34, 
'Health institution Daytime' =35,
'Terminal' =16,
'Industry or craftsmanship 3 x 8h' =36,
'Industry or craftsmanship 8 a.m. to 6 p.m.' =37,
'Court and courthouse' =15,
'Gymnasium and fitness room Municipal or private' =33,
'Restaurant School - 1 meal/day |  5 days a week' =28, 
'Restaurant School - 3 meals/day |  5 days a week' =29,
'Health establishment with accommodation' =3,
'Shelter for young workers'=18, 
'University campus' =38, 
'Datacenter'=39 ,
'Airport' =40,
'External infrastructure' =41
}

export const outdoorProjectBuildingTemplate = {
  "name": "Bâtiment 1",
  "area": 1,
  "zones": [{
    "type": "External infrastructure",
    "name": "Zone 1",
    "category": "CE1",
    "area": 1
  }]
};

export interface ShortAddress extends Pick<Address, "name" | "citycode" | "city">{};

export interface ZoneWithFlag extends Zone {
  flag?: number | null;
  area: any;
  Zones?: ZoneWithFlag[]
}

export interface selfConsumptionRate {
  annualSelfConsumption: number;
  annualProduction: number;
}

export interface zoneRequest extends baseZoneRequest {
  area: number;
  type: ZoneType;
  groundExpansion?: number;
  isSharedArea?: boolean;
  surfaceParkingSpotCount?: number; //nbParkingSpotsSurface
  pluSurfaceParkingSpotCount?: number; // nbParkingSpotsSurfacePlu
  undergroundParkingSpotCount?: number; //nbParkingSpotsUnderground
  pluUndergroundParkingSpotCount?: number; //nbParkingSpotsUndergroundPlu
  thermalSurface?: number; // srt
  occupantCount?: number; // nbOccupants
  dwellingCount?: number; // nbLgt
  category?: EpcmZoneCategory;
  isConnectedToUrbanNetwork?: boolean;
  selfConsumptionRate?: selfConsumptionRate;
}

export interface buildingRequest extends baseZoneRequest {
  zones: zoneRequest[],
  area: number,
}

export interface plotRequest extends baseZoneRequest {
  area: number;
}

export interface baseZoneRequest {
  name?: string;
}

export interface projectRequest {
  /**
   * Optional custom code for the project.
   */
  code?: string;
  company: number;
  name: string;
  inCharge: string;
  address: ShortAddress;
  phase: Phase;
  type: ProjectTemplateType;
  permitDate?: Date;
  buildings: buildingRequest[];
  plot?: plotRequest;
  refUnit: ProjectUnit;
  hasBuildingSite: boolean;
  /**
   * The duration of the building site in years.
   */
  buildingSiteDuration?: number;
}

export interface plot extends plotRequest {
  id: number;
  buildingSite?: buildingSite;
}

export interface building extends buildingRequest {
  id: number;
  zones: zone[];
  area: number;
  // buildingDataComp?: string
}

export interface zone extends zoneRequest {
  id: number;
  buildingSite?: buildingSite;
}

export interface buildingSite extends baseZoneRequest {
  id: number;
}

/**
 * Project objects allow you to associate actions performed
 * in the system with the user that performed them.
 * The User object contains all the information about your project structure (plot, buildings, zones and building sites) and other project details.
 * It also contains its own id and zone ids that can be used to create new project variants.
 */
export interface project extends projectRequest {
  /**
   * The unique identifier of the project.
   * To be referenced to create a new project variant.
   */
  id: number;
  /**
   * The total impact of the project in kgCO2eq. 
   */
  dynamicAcv: number;
  /**
   * The optimization score for this project.
   * The higher the score, the better the project is optimized.
   * The score is a number between 0 and 100.
   */
  optimizationScore: number;
  /**
   * The verification score for this project.
   * The higher the score, the more reliable the computed impact is.
   * The score is a number between 0 and 100.
   */
  verificationScore: number;
  /**
   * The total area of the project in square meters.
   */
  area: number;
  plot?: plot;
  buildings: building[];
  createdAt: Date;
}

export interface variantRequest {
  project: number;
  name?: string;
  contributors: contributorRequest[];
}

export interface contributorRequest {
  name: string;
  code?: string;
  row?: number;
  quantity: number;
  comment?: string;
  unit: string;
  zone?: number;
}

export interface variantRequest {
  contributors: contributorRequest[];
}

export interface variantStatus {
  /**
   * The unique identifier of the project variant.
   * Can be used in the Get Project by Id endpoint to retrieve the project variant.
   */
  project: number;
  /**
   * The status of the creation process.
   */
  status: status;
  /**
   * Start date of the creation process.
   * @format date-time
   */
  createdAt: Date;
}

export function getGetProjectsReturnBody(body: project[]): SuccessReturnBody {
  return getSuccessReturnBody(body)
}

export function getGetProjectByIdReturnBody(body: project): SuccessReturnBody {
  return getSuccessReturnBody(body)
}

export function getPostProjectVariantReturnBody(body: variantStatus, location: string): AcceptedReturnBody {
  return {
      statusCode: 202,
      headers: {
          ...headers,
          Location: location
      },
      body: JSON.stringify(body)
  }
}
